export const HomeIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="25">
		<path
			fill="#06519E"
			d="M18.5455 24.0764c1.8043 0 3.2727-1.4728 3.2727-3.2728v-12c0-.3381-.156-.6545-.4211-.8618L11.5789.3055C11.1851 0 10.632 0 10.2393.3055L.421 7.9418A1.0927 1.0927 0 0 0 0 8.8036v12c0 1.8 1.4684 3.2728 3.2727 3.2728h15.2728Zm-3.2728-2.1818h3.2728c.6021 0 1.0909-.491 1.0909-1.091V9.3382L10.909 2.5527 2.1818 9.3382v11.4654c0 .6.4898 1.091 1.091 1.091h3.2727v-9.8182c0-.6.4887-1.091 1.0909-1.091h6.5454c.6033 0 1.091.491 1.091 1.091v9.8182Zm-6.5454 0v-8.7273h4.3636v8.7273H8.7273Z"
			fillRule="evenodd"
		/>
	</svg>
);
